import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.facade'
import { SelectedProfileFacade } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.facade'
import { GbPaymentService } from '../gb-payment.service'
import { GbStripeService } from 'libs/gb-front/payment/data-access-stripe/src/lib/gb-stripe.service'
import { GbStripeFacade } from 'libs/gb-front/payment/data-access-stripe/src/lib/+state/gb-stripe.facade'
import { Subscription, take, timer } from 'rxjs'
import { CustomerPaymentMethodsFacade } from 'libs/gb-front/payment/data-access-customer-payment-methods/src/lib/+state/customer-payment-methods.facade'
import {
  BillingPageEnum,
  GbBillingViewService,
} from 'libs/gb-front/account/feature/src/lib/gb-billing/gb-billing-view.service'
import { PaymentTypeEnum, PreAuthResultEnum } from '../gb-payment.models'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import * as CustomerPaymentMethodsActions from 'libs/gb-front/payment/data-access-customer-payment-methods/src/lib/+state/customer-payment-methods.actions'
import * as SelectedItemActions from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.actions'
import * as StripeActions from 'libs/gb-front/payment/data-access-stripe/src/lib/+state/gb-stripe.actions'
import { BrandingService } from 'libs/gb-front/auction/branding/src/lib/branding.service'

@Component({
  selector: 'gb-pre-auth-dialog',
  templateUrl: './gb-pre-auth-dialog.component.html',
  styleUrls: ['./gb-pre-auth-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPreAuthDialogComponent implements OnInit, OnDestroy {
  isVolunteer$ = this.authFacade.isVolunteer$
  selectedProfileFirstName$ = this.selectedProfileFacade.selectedProfileFirstName$
  payment$ = this.gbStripeService.payment$
  paymentSessionExpired$ = this.gbPaymentService.paymentSessionExpired$
  pageShowing$ = this.gbBillingViewService.pageShowing$
  selectedcPaymentMethodUuid$ = this.customerPaymentMethodsFacade.selectedCustomerPaymentMethodUuid$
  selectedProfileCreditCardRequired$ = this.selectedProfileFacade.selectedProfileCreditCardRequired$
  isSaas$ = this.auctionFacade.isSaas$
  paymentElementReady$ = this.gbStripeService.paymentElementReady$

  // invalidate payment intent after 1 hour
  PAYMENT_INTENT_SESSION_TIME = 3600000
  sessionTimerSub!: Subscription
  billingPage = BillingPageEnum

  get isDarkTheme(): boolean {
    return this.brandingService.theme === 'dark'
  }

  constructor(
    private authFacade: AuthFacade,
    private selectedProfileFacade: SelectedProfileFacade,
    private stripeFacade: GbStripeFacade,
    private auctionFacade: AuctionFacade,
    private customerPaymentMethodsFacade: CustomerPaymentMethodsFacade,
    private gbPaymentService: GbPaymentService,
    private gbStripeService: GbStripeService,
    private gbBillingViewService: GbBillingViewService,
    private brandingService: BrandingService,
  ) {}

  ngOnInit(): void {
    this.startSessionTimer()
    this.gbPaymentService.initPayment({ paymentType: PaymentTypeEnum.PreAuth })
  }

  ngOnDestroy(): void {
    this.gbPaymentService.clearPayment()
    this.gbPaymentService.setPaymentSessionExpired(false)
    this.sessionTimerSub.unsubscribe()
    this.gbBillingViewService.goToCardList()
    this.customerPaymentMethodsFacade.dispatch(CustomerPaymentMethodsActions.clearSelectedCustomerPaymentMethod())
  }

  startSessionTimer(): void {
    this.sessionTimerSub = timer(this.PAYMENT_INTENT_SESSION_TIME)
      .pipe(take(1))
      .subscribe(() => {
        this.gbPaymentService.setPaymentSessionExpired(true)
        this.stripeFacade.dispatch(StripeActions.cancelPaymentIntent())
      })
  }

  onAddCard(): void {
    this.stripeFacade.dispatch(
      StripeActions.confirmCardSetup({
        onSuccess: () => SelectedItemActions.preAuthSuccess(PreAuthResultEnum.ManualCard),
      }),
    )
  }

  /**
   * Below is called when component is destroyed outside
   * of angular workflow (i.e. user leaves/refreshes page)
   */
  @HostListener('window:beforeunload')
  onBeforeUnload(): void {
    this.ngOnDestroy()
  }
}
